import { connect } from '@atlassian/jira-react-redux';
import mapDispatchToProps from './command';

import mapStateToProps from './query';
import View from './view';

const connector = connect(mapStateToProps, mapDispatchToProps);

// @ts-expect-error - TS2345 - Argument of type '(props: ActiveProps) => JSX.Element' is not assignable to parameter of type 'Component<{ handleSubmit: (id: string) => null | undefined; handleCancel: () => null | undefined; handleCancelAll: () => null | undefined; handleFailure: () => null | undefined; }>'.
export default connector(View);
